import React from 'react';
import { ArrowBack, Home } from '@material-ui/icons';
import { Button, createStyles, Grid, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import WarningImg from '../assets/images/warning.svg';
import LogoIsset from '../assets/images/isset-logo.png';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        notFoundContent: {
            '&': {
                height: '100vh',
                width: '100%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative'
            }
        },
        infoContent: {
            '&': {
                display: 'block',
                width: '110%',
                height: 800,
                position: 'absolute',
                zIndex: -1,
                bottom: '-75%',
                backgroundColor: theme.palette.primary.main,
                opacity: 0.4,
                borderRadius: '100%'
            }
        },
        paperContent: {
            '&': {
                maxWidth: 480,
                padding: '60px 45px',
                textAlign: 'center',
                boxShadow: '0px 15px 45px rgba(157, 36, 73, 0.3)'
            },
            '& h1': {
                marginTop: 0,
                fontWeight: 'bold',
                color: theme.palette.primary.main
            },
            '& > *:nth-child(3)': {
                marginTop: 0,
                fontWeight: 'bold'
            },
            '& > *:nth-child(4)': {
                marginTop: 40
            },
        },
        buttons: {
            '&': {
                marginTop: theme.spacing(4)
            },
            '& > *': {
                marginTop: theme.spacing(2),
                marginRight: 15
            },
            '& > *:last-child()': {
                marginRight: 0
            }
        },
        warningTop: {
            '&': {
                width: 70,
                top: -11,
                left: -13,
                position: 'absolute'
            }
        },
        warningBottom: {
            '&': {
                width: 70,
                bottom: -11,
                right: -13,
                position: 'absolute'
            }
        }
    })
);

const NotFound = () => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.notFoundContent}>
            {/* <div className={classes.infoContent}></div> */}

            <div style={{ position: 'relative' }}>
                <img className={classes.warningTop} src={WarningImg} alt="warning" />

                <Paper className={classes.paperContent}>
                    <img src={LogoIsset} alt="ISSET Logo" style={{ width: 90, zIndex: 5 }} />

                    <Typography variant="h1">404</Typography>

                    <Typography variant="h4">Página no encontrada</Typography>

                    <Typography variant="body2">La página que usted está buscando no existe. Es posible que el enlace que haya escrito esté mal, o haya caducado.</Typography>

                    <Grid container alignItems="center" justify="center" className={classes.buttons}>
                        <Grid item>
                            <Button variant="outlined" color="primary" startIcon={<ArrowBack />} onClick={() => history.goBack()}>Regresar</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" startIcon={<Home />} onClick={() => history.push('/')}>Ir al inicio</Button>
                        </Grid>
                    </Grid>
                </Paper>

                <img className={classes.warningBottom} src={WarningImg} alt="warning" />
            </div>
        </div>
    );
};


export default NotFound;